import { Dialog } from 'antd-mobile';
import VConsole from 'vconsole';
export const GrtDialog = {
    confirm: (config) => {
        Dialog.confirm({
            ...config,
            cancelText: config.cancelText || <span style={{ color: '#999999' }}>取消</span>
        });
    },
    alert: (config) => {
        Dialog.alert({
            ...config,
            cancelText: config.cancelText || <span style={{ color: '#999999' }}>取消</span>
        });
    },
    clear: () => {
        Dialog.clear();
    }
};

let lastTime = 0,
    count = 0,
    maxCount = 20,
    interval = 500;
export const openConsole = () => {
    const date = new Date();
    if (date.getTime() - lastTime > interval) {
        lastTime = 0;
    }
    if (count === 0) {
        count++;
        lastTime = date.getTime();
        return;
    }
    const currentInterval = date.getTime() - lastTime;
    if (currentInterval < interval) {
        if (count > maxCount - 1) {
            if (!window.vConsole) {
                window.vConsole = new VConsole();
            }
            count = 0;
            lastTime = 0;
            return;
        }

        count++;
        lastTime = date.getTime();
        return;
    }
    count = 0;
    lastTime = 0;
};
export const openEgg = (cb) => {
    const date = new Date();
    if (date.getTime() - lastTime > interval) {
        lastTime = 0;
    }
    if (count === 0) {
        count++;
        lastTime = date.getTime();
        return;
    }
    const currentInterval = date.getTime() - lastTime;
    if (currentInterval < interval) {
        if (count > maxCount - 1) {
            cb()
            count = 0;
            lastTime = 0;
            return;
        }

        count++;
        lastTime = date.getTime();
        return;
    }
    count = 0;
    lastTime = 0;
};
export const getOS = () => {
    let ua = navigator.userAgent.toLowerCase();

    if (ua.indexOf('micromessenger') > -1) {
        return 'wx';
    }
    if (ua.indexOf('android') > -1 || ua.indexOf('linux') > -1) {
        return 'android';
    }
    if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        return 'ios';
    }

    return 'others';
};
let originalHeight = window.innerHeight;
export const handleKeyboardHeightChange = () => {
    window.addEventListener('resize', () => {
        const currentHeight = window.innerHeight;
        const keyboardHeight = originalHeight - currentHeight;

        if (keyboardHeight > 50) {
            // 键盘弹出
            document.body.style.paddingBottom = `${keyboardHeight}px`;
        } else {
            // 键盘收起
            document.body.style.paddingBottom = '0';
        }
    });
};
export const linkApp = (params) => {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(params);
};

export const isInApp = () => {
    let urlSearch = new URLSearchParams(window.location.search);
    let ufoAgent = urlSearch.get('ufo-agent');
    if (ufoAgent === 'grtedu') {
        return true;
    }
    return false;
};
export const goAppLogin = () => {
    linkApp('grtedu://login?go-login=mobile');
};
